function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#cacaca;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill-rule:evenodd;}.cls-2{fill:#ced0d2;}.cls-3{fill:#e4e4e5;}.cls-4{fill:#f8fafb;}.cls-5{fill:#f3f4f5;}.cls-6{fill:#f1f1f2;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M48.17,15.38h0A2.71,2.71,0,0,1,50.9,18.1v5.51a2.72,2.72,0,0,1-2.73,2.73h0a2.72,2.72,0,0,1-2.68-2.73V18.1a2.71,2.71,0,0,1,2.68-2.72Z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M63.72,19.76h0a2.71,2.71,0,0,1,.68,3.75l-3.21,4.54a2.8,2.8,0,0,1-3.81.68h0a2.73,2.73,0,0,1-.63-3.8l3.17-4.54a2.73,2.73,0,0,1,3.8-.63Z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M74.49,29.8h0a2.76,2.76,0,0,1-1,3.7l-4.88,2.73a2.71,2.71,0,0,1-3.7-1h0a2.71,2.71,0,0,1,1-3.7l4.88-2.73a2.77,2.77,0,0,1,3.7,1Z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M47.88,76.24h0a2.73,2.73,0,0,1-2.73-2.73V68a2.73,2.73,0,0,1,2.73-2.73h0A2.73,2.73,0,0,1,50.61,68v5.5a2.73,2.73,0,0,1-2.73,2.73Z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M32.34,71.86h0a2.68,2.68,0,0,1-.64-3.76l3.17-4.53a2.78,2.78,0,0,1,3.8-.68h0a2.73,2.73,0,0,1,.64,3.8l-3.17,4.53a2.74,2.74,0,0,1-3.8.64Z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-3",
  d: "M21.52,61.33h0a2.68,2.68,0,0,1,1-3.66L27.41,55a2.66,2.66,0,0,1,3.66,1h0a2.62,2.62,0,0,1-1,3.65l-4.83,2.73a2.7,2.7,0,0,1-3.7-1Z"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M63.09,72.78h0a2.67,2.67,0,0,0,1.21-3.6l-2.43-5a2.7,2.7,0,0,0-3.61-1.26h0A2.7,2.7,0,0,0,57,66.54l2.44,5a2.72,2.72,0,0,0,3.66,1.27Z"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-2",
  d: "M74.59,61.28h0a2.69,2.69,0,0,0-1.08-3.65L68.64,54.9A2.76,2.76,0,0,0,64.94,56h0A2.72,2.72,0,0,0,66,59.67l4.87,2.68a2.77,2.77,0,0,0,3.71-1.07Z"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-4",
  d: "M33.31,19.91h0A2.7,2.7,0,0,0,32,23.51l2.44,5a2.66,2.66,0,0,0,3.61,1.27h0a2.66,2.66,0,0,0,1.26-3.61l-2.43-5a2.7,2.7,0,0,0-3.61-1.26Z"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-5",
  d: "M21.37,31.07h0a2.71,2.71,0,0,0,1,3.7l4.87,2.68A2.73,2.73,0,0,0,31,36.38h0a2.66,2.66,0,0,0-1.07-3.66L25,30a2.75,2.75,0,0,0-3.66,1.08Z"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M78.58,45.83h0a2.72,2.72,0,0,1-2.73,2.68h-5.5a2.72,2.72,0,0,1-2.73-2.68h0a2.73,2.73,0,0,1,2.73-2.73h5.5a2.73,2.73,0,0,1,2.73,2.73Z"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-6",
  d: "M28.88,45.83h0a2.72,2.72,0,0,1-2.73,2.68H20.64a2.72,2.72,0,0,1-2.73-2.68h0a2.73,2.73,0,0,1,2.73-2.73h5.51a2.73,2.73,0,0,1,2.73,2.73Z"
});

var SvgLoaders = function SvgLoaders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    viewBox: "0 0 96 96",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoaders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LOADERS.31bdd2e5.svg";
export { ForwardRef as ReactComponent };